module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_41.f418ab71.png";